module.exports = __webpack_public_path__ + "6bc95d4db95917284cd8079b0ccd69bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.ttf?edd5f759e39cf0af8ed039b31ef6e852
// module id = 349
// module chunks = 0